import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';

const BYPASS_TOKEN_KEY = 'maintenanceBypassToken';

export const useMaintenanceMode = () => {
  const [maintenanceStatus, setMaintenanceStatus] = useState({
    isMaintenanceMode: false,
    hasBypass: false,
    isLoading: true,
    error: null
  });

  // Get stored bypass token from localStorage
  const getStoredBypassToken = () => {
    return localStorage.getItem(BYPASS_TOKEN_KEY);
  };

  const checkMaintenanceStatus = async () => {
    try {
      const storedToken = getStoredBypassToken();

      // Use POST with token in body to avoid exposing it in URLs/logs
      const url = `${API_BASE_URL}/maintenance/status`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bypassToken: storedToken || null }),
      });

      if (response.ok) {
        const data = await response.json();

        // If server says bypass is invalid, clear the stored token
        if (storedToken && !data.hasBypass) {
          localStorage.removeItem(BYPASS_TOKEN_KEY);
        }

        setMaintenanceStatus({
          isMaintenanceMode: data.maintenanceMode,
          hasBypass: data.hasBypass,
          isLoading: false,
          error: null
        });
      } else {
        // If we can't reach the maintenance endpoint, assume no maintenance mode
        setMaintenanceStatus({
          isMaintenanceMode: false,
          hasBypass: false,
          isLoading: false,
          error: null
        });
      }
    } catch (error) {
      // If there's a network error, assume no maintenance mode to avoid blocking users
      setMaintenanceStatus({
        isMaintenanceMode: false,
        hasBypass: false,
        isLoading: false,
        error: error.message
      });
    }
  };

  // Called when authentication succeeds - stores the server-issued token
  const grantBypass = (bypassToken) => {
    if (bypassToken) {
      localStorage.setItem(BYPASS_TOKEN_KEY, bypassToken);
    }

    setMaintenanceStatus(prev => ({
      ...prev,
      hasBypass: true
    }));
  };

  useEffect(() => {
    checkMaintenanceStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...maintenanceStatus,
    refetch: checkMaintenanceStatus,
    grantBypass
  };
};